module.exports = __webpack_public_path__ + "img/textscreen3.ff68c586.png";